export default __webpack_public_path__ + "static/media/logo.acb0d11c.png";